import sortBy from "lodash/sortBy";

export const getSortedUnitTypes = (unitTypes = []) => {
  if (!unitTypes) return [];
  return sortBy(unitTypes, ut => ut.sortOrder || 0);
};

export const getActiveSortedUnitTypes = (unitTypes = []) => {
  if (!unitTypes) return [];
  return getSortedUnitTypes(unitTypes.filter(ut => ut.isActive));
};
